/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as ShowinfosRouteImport } from './routes/showinfos'
import { Route as ShowconfigurationRouteImport } from './routes/showconfiguration'
import { Route as LoginRouteImport } from './routes/login'
import { Route as LicensingslidesRouteImport } from './routes/licensingslides'
import { Route as IntroslidesRouteImport } from './routes/introslides'
import { Route as HomeRouteImport } from './routes/home'
import { Route as HivemqdatahubRouteImport } from './routes/hivemqdatahub'
import { Route as DhhomeRouteImport } from './routes/dhhome'
import { Route as ConfigurationRouteImport } from './routes/configuration'
import { Route as CarRouteImport } from './routes/car'
import { Route as ApplicationunsRouteImport } from './routes/applicationuns'
import { Route as ApplicationintroRouteImport } from './routes/applicationintro'
import { Route as ApplicationflowRouteImport } from './routes/applicationflow'
import { Route as AppRouteImport } from './routes/_app'
import { Route as AppIndexRouteImport } from './routes/_app/index'
import { Route as SShortCodeRouteImport } from './routes/s/$shortCode'
import { Route as LoginCallbackRouteImport } from './routes/login_.callback'
import { Route as AppValuespaceRouteImport } from './routes/_app/valuespace'
import { Route as AppPulseRouteImport } from './routes/_app/pulse'
import { Route as AppPlaygroundRouteImport } from './routes/_app/playground'
import { Route as AppMqttClientRouteImport } from './routes/_app/mqtt-client'
import { Route as AppHivemqvisionRouteImport } from './routes/_app/hivemqvision'
import { Route as AppHivemqpilarsRouteImport } from './routes/_app/hivemqpilars'
import { Route as AppHivemqintroRouteImport } from './routes/_app/hivemqintro'
import { Route as AppHivemqedgeRouteImport } from './routes/_app/hivemqedge'
import { Route as AppHivemqagenticRouteImport } from './routes/_app/hivemqagentic'
import { Route as AppDhsparkplugfanoutflowRouteImport } from './routes/_app/dhsparkplugfanoutflow'
import { Route as AppDhgeolocationflowRouteImport } from './routes/_app/dhgeolocationflow'
import { Route as AppDhftocflowRouteImport } from './routes/_app/dhftocflow'
import { Route as AppDhanonymizeflowRouteImport } from './routes/_app/dhanonymizeflow'
import { Route as AppDemoinfoRouteImport } from './routes/_app/demoinfo'
import { Route as AppDatahubRouteImport } from './routes/_app/datahub'
import { Route as AppAdminRouteImport } from './routes/_app/admin'
import { Route as AppPharmaIndexRouteImport } from './routes/_app/pharma/index'
import { Route as AppOilandgasIndexRouteImport } from './routes/_app/oilandgas/index'
import { Route as AppLogisticsIndexRouteImport } from './routes/_app/logistics/index'
import { Route as AppFactoryIndexRouteImport } from './routes/_app/factory/index'
import { Route as AppEnergyIndexRouteImport } from './routes/_app/energy/index'
import { Route as AppEducationIndexRouteImport } from './routes/_app/education/index'
import { Route as AppDatacenterIndexRouteImport } from './routes/_app/datacenter/index'
import { Route as AppConnectedIndexRouteImport } from './routes/_app/connected/index'
import { Route as AppBusinessValueIndexRouteImport } from './routes/_app/business-value/index'
import { Route as AppAutomotiveIndexRouteImport } from './routes/_app/automotive/index'
import { Route as AppPharmaKnowledgeGraphRouteImport } from './routes/_app/pharma/knowledge-graph'
import { Route as AppPharmaFlowRouteImport } from './routes/_app/pharma/flow'
import { Route as AppPharmaExplorerRouteImport } from './routes/_app/pharma/explorer'
import { Route as AppPharmaBotRouteImport } from './routes/_app/pharma/bot'
import { Route as AppOilandgasKnowledgeGraphRouteImport } from './routes/_app/oilandgas/knowledge-graph'
import { Route as AppOilandgasFlowRouteImport } from './routes/_app/oilandgas/flow'
import { Route as AppOilandgasExplorerRouteImport } from './routes/_app/oilandgas/explorer'
import { Route as AppOilandgasBotRouteImport } from './routes/_app/oilandgas/bot'
import { Route as AppLogisticsKnowledgeGraphRouteImport } from './routes/_app/logistics/knowledge-graph'
import { Route as AppLogisticsFlowRouteImport } from './routes/_app/logistics/flow'
import { Route as AppLogisticsExplorerRouteImport } from './routes/_app/logistics/explorer'
import { Route as AppLogisticsBotRouteImport } from './routes/_app/logistics/bot'
import { Route as AppFactoryMultisiteflowRouteImport } from './routes/_app/factory/multisiteflow'
import { Route as AppFactoryLineRouteImport } from './routes/_app/factory/line'
import { Route as AppFactoryKnowledgeGraphRouteImport } from './routes/_app/factory/knowledge-graph'
import { Route as AppFactoryFlowRouteImport } from './routes/_app/factory/flow'
import { Route as AppFactoryExplorerRouteImport } from './routes/_app/factory/explorer'
import { Route as AppFactoryBotRouteImport } from './routes/_app/factory/bot'
import { Route as AppFactoryAdvancedflowRouteImport } from './routes/_app/factory/advancedflow'
import { Route as AppEnergyKnowledgeGraphRouteImport } from './routes/_app/energy/knowledge-graph'
import { Route as AppEnergyFlowRouteImport } from './routes/_app/energy/flow'
import { Route as AppEnergyExplorerRouteImport } from './routes/_app/energy/explorer'
import { Route as AppEnergyBotRouteImport } from './routes/_app/energy/bot'
import { Route as AppEducationUnsRouteImport } from './routes/_app/education/uns'
import { Route as AppEducationTlsMtlsRouteImport } from './routes/_app/education/tls-mtls'
import { Route as AppEducationSparkplugRouteImport } from './routes/_app/education/sparkplug'
import { Route as AppEducationMqttRouteImport } from './routes/_app/education/mqtt'
import { Route as AppEducationHivemqClusterRouteImport } from './routes/_app/education/hivemq-cluster'
import { Route as AppDatacenterMultisiteflowRouteImport } from './routes/_app/datacenter/multisiteflow'
import { Route as AppDatacenterKnowledgeGraphRouteImport } from './routes/_app/datacenter/knowledge-graph'
import { Route as AppDatacenterFlowRouteImport } from './routes/_app/datacenter/flow'
import { Route as AppDatacenterExplorerRouteImport } from './routes/_app/datacenter/explorer'
import { Route as AppDatacenterBotRouteImport } from './routes/_app/datacenter/bot'
import { Route as AppCustomersSlugRouteImport } from './routes/_app/customers/$slug'
import { Route as AppConnectedTracingRouteImport } from './routes/_app/connected/tracing'
import { Route as AppConnectedKnowledgeGraphRouteImport } from './routes/_app/connected/knowledge-graph'
import { Route as AppConnectedFlowRouteImport } from './routes/_app/connected/flow'
import { Route as AppConnectedExplorerRouteImport } from './routes/_app/connected/explorer'
import { Route as AppConnectedBotRouteImport } from './routes/_app/connected/bot'
import { Route as AppBusinessValueSmartManufacturingRouteImport } from './routes/_app/business-value/smart-manufacturing'
import { Route as AppBusinessValueLogisticsRouteImport } from './routes/_app/business-value/logistics'
import { Route as AppBusinessValueEnergyRouteImport } from './routes/_app/business-value/energy'
import { Route as AppBusinessValueDataCentersRouteImport } from './routes/_app/business-value/data-centers'
import { Route as AppAutomotiveKnowledgeGraphRouteImport } from './routes/_app/automotive/knowledge-graph'
import { Route as AppAutomotiveFlowRouteImport } from './routes/_app/automotive/flow'
import { Route as AppAutomotiveExplorerRouteImport } from './routes/_app/automotive/explorer'
import { Route as AppAutomotiveBotRouteImport } from './routes/_app/automotive/bot'
import { Route as AppAdminUsersRouteImport } from './routes/_app/admin/users'
import { Route as AppAdminSettingsRouteImport } from './routes/_app/admin/settings'
import { Route as AppAdminPlaygroundNodesRouteImport } from './routes/_app/admin/playground-nodes'
import { Route as AppAdminK8sRouteImport } from './routes/_app/admin/k8s'
import { Route as AppAdminFlowTemplatesRouteImport } from './routes/_app/admin/flow-templates'
import { Route as AppAdminCustomersRouteImport } from './routes/_app/admin/customers'
import { Route as AppAdminAuditRouteImport } from './routes/_app/admin/audit'
import { Route as AppAdminActivityUsersRouteImport } from './routes/_app/admin/activity-users'
import { Route as AppAdminActivityPagesRouteImport } from './routes/_app/admin/activity-pages'
import { Route as AppAdminActivityExternalLinksRouteImport } from './routes/_app/admin/activity-external-links'
import { Route as AppAdminActivityRouteImport } from './routes/_app/admin/activity'

const ShowinfosRoute = ShowinfosRouteImport.update({
  id: '/showinfos',
  path: '/showinfos',
  getParentRoute: () => rootRouteImport,
} as any)
const ShowconfigurationRoute = ShowconfigurationRouteImport.update({
  id: '/showconfiguration',
  path: '/showconfiguration',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const LicensingslidesRoute = LicensingslidesRouteImport.update({
  id: '/licensingslides',
  path: '/licensingslides',
  getParentRoute: () => rootRouteImport,
} as any)
const IntroslidesRoute = IntroslidesRouteImport.update({
  id: '/introslides',
  path: '/introslides',
  getParentRoute: () => rootRouteImport,
} as any)
const HomeRoute = HomeRouteImport.update({
  id: '/home',
  path: '/home',
  getParentRoute: () => rootRouteImport,
} as any)
const HivemqdatahubRoute = HivemqdatahubRouteImport.update({
  id: '/hivemqdatahub',
  path: '/hivemqdatahub',
  getParentRoute: () => rootRouteImport,
} as any)
const DhhomeRoute = DhhomeRouteImport.update({
  id: '/dhhome',
  path: '/dhhome',
  getParentRoute: () => rootRouteImport,
} as any)
const ConfigurationRoute = ConfigurationRouteImport.update({
  id: '/configuration',
  path: '/configuration',
  getParentRoute: () => rootRouteImport,
} as any)
const CarRoute = CarRouteImport.update({
  id: '/car',
  path: '/car',
  getParentRoute: () => rootRouteImport,
} as any)
const ApplicationunsRoute = ApplicationunsRouteImport.update({
  id: '/applicationuns',
  path: '/applicationuns',
  getParentRoute: () => rootRouteImport,
} as any)
const ApplicationintroRoute = ApplicationintroRouteImport.update({
  id: '/applicationintro',
  path: '/applicationintro',
  getParentRoute: () => rootRouteImport,
} as any)
const ApplicationflowRoute = ApplicationflowRouteImport.update({
  id: '/applicationflow',
  path: '/applicationflow',
  getParentRoute: () => rootRouteImport,
} as any)
const AppRoute = AppRouteImport.update({
  id: '/_app',
  getParentRoute: () => rootRouteImport,
} as any)
const AppIndexRoute = AppIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppRoute,
} as any)
const SShortCodeRoute = SShortCodeRouteImport.update({
  id: '/s/$shortCode',
  path: '/s/$shortCode',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginCallbackRoute = LoginCallbackRouteImport.update({
  id: '/login_/callback',
  path: '/login/callback',
  getParentRoute: () => rootRouteImport,
} as any)
const AppValuespaceRoute = AppValuespaceRouteImport.update({
  id: '/valuespace',
  path: '/valuespace',
  getParentRoute: () => AppRoute,
} as any)
const AppPulseRoute = AppPulseRouteImport.update({
  id: '/pulse',
  path: '/pulse',
  getParentRoute: () => AppRoute,
} as any)
const AppPlaygroundRoute = AppPlaygroundRouteImport.update({
  id: '/playground',
  path: '/playground',
  getParentRoute: () => AppRoute,
} as any)
const AppMqttClientRoute = AppMqttClientRouteImport.update({
  id: '/mqtt-client',
  path: '/mqtt-client',
  getParentRoute: () => AppRoute,
} as any)
const AppHivemqvisionRoute = AppHivemqvisionRouteImport.update({
  id: '/hivemqvision',
  path: '/hivemqvision',
  getParentRoute: () => AppRoute,
} as any)
const AppHivemqpilarsRoute = AppHivemqpilarsRouteImport.update({
  id: '/hivemqpilars',
  path: '/hivemqpilars',
  getParentRoute: () => AppRoute,
} as any)
const AppHivemqintroRoute = AppHivemqintroRouteImport.update({
  id: '/hivemqintro',
  path: '/hivemqintro',
  getParentRoute: () => AppRoute,
} as any)
const AppHivemqedgeRoute = AppHivemqedgeRouteImport.update({
  id: '/hivemqedge',
  path: '/hivemqedge',
  getParentRoute: () => AppRoute,
} as any)
const AppHivemqagenticRoute = AppHivemqagenticRouteImport.update({
  id: '/hivemqagentic',
  path: '/hivemqagentic',
  getParentRoute: () => AppRoute,
} as any)
const AppDhsparkplugfanoutflowRoute =
  AppDhsparkplugfanoutflowRouteImport.update({
    id: '/dhsparkplugfanoutflow',
    path: '/dhsparkplugfanoutflow',
    getParentRoute: () => AppRoute,
  } as any)
const AppDhgeolocationflowRoute = AppDhgeolocationflowRouteImport.update({
  id: '/dhgeolocationflow',
  path: '/dhgeolocationflow',
  getParentRoute: () => AppRoute,
} as any)
const AppDhftocflowRoute = AppDhftocflowRouteImport.update({
  id: '/dhftocflow',
  path: '/dhftocflow',
  getParentRoute: () => AppRoute,
} as any)
const AppDhanonymizeflowRoute = AppDhanonymizeflowRouteImport.update({
  id: '/dhanonymizeflow',
  path: '/dhanonymizeflow',
  getParentRoute: () => AppRoute,
} as any)
const AppDemoinfoRoute = AppDemoinfoRouteImport.update({
  id: '/demoinfo',
  path: '/demoinfo',
  getParentRoute: () => AppRoute,
} as any)
const AppDatahubRoute = AppDatahubRouteImport.update({
  id: '/datahub',
  path: '/datahub',
  getParentRoute: () => AppRoute,
} as any)
const AppAdminRoute = AppAdminRouteImport.update({
  id: '/admin',
  path: '/admin',
  getParentRoute: () => AppRoute,
} as any)
const AppPharmaIndexRoute = AppPharmaIndexRouteImport.update({
  id: '/pharma/',
  path: '/pharma/',
  getParentRoute: () => AppRoute,
} as any)
const AppOilandgasIndexRoute = AppOilandgasIndexRouteImport.update({
  id: '/oilandgas/',
  path: '/oilandgas/',
  getParentRoute: () => AppRoute,
} as any)
const AppLogisticsIndexRoute = AppLogisticsIndexRouteImport.update({
  id: '/logistics/',
  path: '/logistics/',
  getParentRoute: () => AppRoute,
} as any)
const AppFactoryIndexRoute = AppFactoryIndexRouteImport.update({
  id: '/factory/',
  path: '/factory/',
  getParentRoute: () => AppRoute,
} as any)
const AppEnergyIndexRoute = AppEnergyIndexRouteImport.update({
  id: '/energy/',
  path: '/energy/',
  getParentRoute: () => AppRoute,
} as any)
const AppEducationIndexRoute = AppEducationIndexRouteImport.update({
  id: '/education/',
  path: '/education/',
  getParentRoute: () => AppRoute,
} as any)
const AppDatacenterIndexRoute = AppDatacenterIndexRouteImport.update({
  id: '/datacenter/',
  path: '/datacenter/',
  getParentRoute: () => AppRoute,
} as any)
const AppConnectedIndexRoute = AppConnectedIndexRouteImport.update({
  id: '/connected/',
  path: '/connected/',
  getParentRoute: () => AppRoute,
} as any)
const AppBusinessValueIndexRoute = AppBusinessValueIndexRouteImport.update({
  id: '/business-value/',
  path: '/business-value/',
  getParentRoute: () => AppRoute,
} as any)
const AppAutomotiveIndexRoute = AppAutomotiveIndexRouteImport.update({
  id: '/automotive/',
  path: '/automotive/',
  getParentRoute: () => AppRoute,
} as any)
const AppPharmaKnowledgeGraphRoute = AppPharmaKnowledgeGraphRouteImport.update({
  id: '/pharma/knowledge-graph',
  path: '/pharma/knowledge-graph',
  getParentRoute: () => AppRoute,
} as any)
const AppPharmaFlowRoute = AppPharmaFlowRouteImport.update({
  id: '/pharma/flow',
  path: '/pharma/flow',
  getParentRoute: () => AppRoute,
} as any)
const AppPharmaExplorerRoute = AppPharmaExplorerRouteImport.update({
  id: '/pharma/explorer',
  path: '/pharma/explorer',
  getParentRoute: () => AppRoute,
} as any)
const AppPharmaBotRoute = AppPharmaBotRouteImport.update({
  id: '/pharma/bot',
  path: '/pharma/bot',
  getParentRoute: () => AppRoute,
} as any)
const AppOilandgasKnowledgeGraphRoute =
  AppOilandgasKnowledgeGraphRouteImport.update({
    id: '/oilandgas/knowledge-graph',
    path: '/oilandgas/knowledge-graph',
    getParentRoute: () => AppRoute,
  } as any)
const AppOilandgasFlowRoute = AppOilandgasFlowRouteImport.update({
  id: '/oilandgas/flow',
  path: '/oilandgas/flow',
  getParentRoute: () => AppRoute,
} as any)
const AppOilandgasExplorerRoute = AppOilandgasExplorerRouteImport.update({
  id: '/oilandgas/explorer',
  path: '/oilandgas/explorer',
  getParentRoute: () => AppRoute,
} as any)
const AppOilandgasBotRoute = AppOilandgasBotRouteImport.update({
  id: '/oilandgas/bot',
  path: '/oilandgas/bot',
  getParentRoute: () => AppRoute,
} as any)
const AppLogisticsKnowledgeGraphRoute =
  AppLogisticsKnowledgeGraphRouteImport.update({
    id: '/logistics/knowledge-graph',
    path: '/logistics/knowledge-graph',
    getParentRoute: () => AppRoute,
  } as any)
const AppLogisticsFlowRoute = AppLogisticsFlowRouteImport.update({
  id: '/logistics/flow',
  path: '/logistics/flow',
  getParentRoute: () => AppRoute,
} as any)
const AppLogisticsExplorerRoute = AppLogisticsExplorerRouteImport.update({
  id: '/logistics/explorer',
  path: '/logistics/explorer',
  getParentRoute: () => AppRoute,
} as any)
const AppLogisticsBotRoute = AppLogisticsBotRouteImport.update({
  id: '/logistics/bot',
  path: '/logistics/bot',
  getParentRoute: () => AppRoute,
} as any)
const AppFactoryMultisiteflowRoute = AppFactoryMultisiteflowRouteImport.update({
  id: '/factory/multisiteflow',
  path: '/factory/multisiteflow',
  getParentRoute: () => AppRoute,
} as any)
const AppFactoryLineRoute = AppFactoryLineRouteImport.update({
  id: '/factory/line',
  path: '/factory/line',
  getParentRoute: () => AppRoute,
} as any)
const AppFactoryKnowledgeGraphRoute =
  AppFactoryKnowledgeGraphRouteImport.update({
    id: '/factory/knowledge-graph',
    path: '/factory/knowledge-graph',
    getParentRoute: () => AppRoute,
  } as any)
const AppFactoryFlowRoute = AppFactoryFlowRouteImport.update({
  id: '/factory/flow',
  path: '/factory/flow',
  getParentRoute: () => AppRoute,
} as any)
const AppFactoryExplorerRoute = AppFactoryExplorerRouteImport.update({
  id: '/factory/explorer',
  path: '/factory/explorer',
  getParentRoute: () => AppRoute,
} as any)
const AppFactoryBotRoute = AppFactoryBotRouteImport.update({
  id: '/factory/bot',
  path: '/factory/bot',
  getParentRoute: () => AppRoute,
} as any)
const AppFactoryAdvancedflowRoute = AppFactoryAdvancedflowRouteImport.update({
  id: '/factory/advancedflow',
  path: '/factory/advancedflow',
  getParentRoute: () => AppRoute,
} as any)
const AppEnergyKnowledgeGraphRoute = AppEnergyKnowledgeGraphRouteImport.update({
  id: '/energy/knowledge-graph',
  path: '/energy/knowledge-graph',
  getParentRoute: () => AppRoute,
} as any)
const AppEnergyFlowRoute = AppEnergyFlowRouteImport.update({
  id: '/energy/flow',
  path: '/energy/flow',
  getParentRoute: () => AppRoute,
} as any)
const AppEnergyExplorerRoute = AppEnergyExplorerRouteImport.update({
  id: '/energy/explorer',
  path: '/energy/explorer',
  getParentRoute: () => AppRoute,
} as any)
const AppEnergyBotRoute = AppEnergyBotRouteImport.update({
  id: '/energy/bot',
  path: '/energy/bot',
  getParentRoute: () => AppRoute,
} as any)
const AppEducationUnsRoute = AppEducationUnsRouteImport.update({
  id: '/education/uns',
  path: '/education/uns',
  getParentRoute: () => AppRoute,
} as any)
const AppEducationTlsMtlsRoute = AppEducationTlsMtlsRouteImport.update({
  id: '/education/tls-mtls',
  path: '/education/tls-mtls',
  getParentRoute: () => AppRoute,
} as any)
const AppEducationSparkplugRoute = AppEducationSparkplugRouteImport.update({
  id: '/education/sparkplug',
  path: '/education/sparkplug',
  getParentRoute: () => AppRoute,
} as any)
const AppEducationMqttRoute = AppEducationMqttRouteImport.update({
  id: '/education/mqtt',
  path: '/education/mqtt',
  getParentRoute: () => AppRoute,
} as any)
const AppEducationHivemqClusterRoute =
  AppEducationHivemqClusterRouteImport.update({
    id: '/education/hivemq-cluster',
    path: '/education/hivemq-cluster',
    getParentRoute: () => AppRoute,
  } as any)
const AppDatacenterMultisiteflowRoute =
  AppDatacenterMultisiteflowRouteImport.update({
    id: '/datacenter/multisiteflow',
    path: '/datacenter/multisiteflow',
    getParentRoute: () => AppRoute,
  } as any)
const AppDatacenterKnowledgeGraphRoute =
  AppDatacenterKnowledgeGraphRouteImport.update({
    id: '/datacenter/knowledge-graph',
    path: '/datacenter/knowledge-graph',
    getParentRoute: () => AppRoute,
  } as any)
const AppDatacenterFlowRoute = AppDatacenterFlowRouteImport.update({
  id: '/datacenter/flow',
  path: '/datacenter/flow',
  getParentRoute: () => AppRoute,
} as any)
const AppDatacenterExplorerRoute = AppDatacenterExplorerRouteImport.update({
  id: '/datacenter/explorer',
  path: '/datacenter/explorer',
  getParentRoute: () => AppRoute,
} as any)
const AppDatacenterBotRoute = AppDatacenterBotRouteImport.update({
  id: '/datacenter/bot',
  path: '/datacenter/bot',
  getParentRoute: () => AppRoute,
} as any)
const AppCustomersSlugRoute = AppCustomersSlugRouteImport.update({
  id: '/customers/$slug',
  path: '/customers/$slug',
  getParentRoute: () => AppRoute,
} as any)
const AppConnectedTracingRoute = AppConnectedTracingRouteImport.update({
  id: '/connected/tracing',
  path: '/connected/tracing',
  getParentRoute: () => AppRoute,
} as any)
const AppConnectedKnowledgeGraphRoute =
  AppConnectedKnowledgeGraphRouteImport.update({
    id: '/connected/knowledge-graph',
    path: '/connected/knowledge-graph',
    getParentRoute: () => AppRoute,
  } as any)
const AppConnectedFlowRoute = AppConnectedFlowRouteImport.update({
  id: '/connected/flow',
  path: '/connected/flow',
  getParentRoute: () => AppRoute,
} as any)
const AppConnectedExplorerRoute = AppConnectedExplorerRouteImport.update({
  id: '/connected/explorer',
  path: '/connected/explorer',
  getParentRoute: () => AppRoute,
} as any)
const AppConnectedBotRoute = AppConnectedBotRouteImport.update({
  id: '/connected/bot',
  path: '/connected/bot',
  getParentRoute: () => AppRoute,
} as any)
const AppBusinessValueSmartManufacturingRoute =
  AppBusinessValueSmartManufacturingRouteImport.update({
    id: '/business-value/smart-manufacturing',
    path: '/business-value/smart-manufacturing',
    getParentRoute: () => AppRoute,
  } as any)
const AppBusinessValueLogisticsRoute =
  AppBusinessValueLogisticsRouteImport.update({
    id: '/business-value/logistics',
    path: '/business-value/logistics',
    getParentRoute: () => AppRoute,
  } as any)
const AppBusinessValueEnergyRoute = AppBusinessValueEnergyRouteImport.update({
  id: '/business-value/energy',
  path: '/business-value/energy',
  getParentRoute: () => AppRoute,
} as any)
const AppBusinessValueDataCentersRoute =
  AppBusinessValueDataCentersRouteImport.update({
    id: '/business-value/data-centers',
    path: '/business-value/data-centers',
    getParentRoute: () => AppRoute,
  } as any)
const AppAutomotiveKnowledgeGraphRoute =
  AppAutomotiveKnowledgeGraphRouteImport.update({
    id: '/automotive/knowledge-graph',
    path: '/automotive/knowledge-graph',
    getParentRoute: () => AppRoute,
  } as any)
const AppAutomotiveFlowRoute = AppAutomotiveFlowRouteImport.update({
  id: '/automotive/flow',
  path: '/automotive/flow',
  getParentRoute: () => AppRoute,
} as any)
const AppAutomotiveExplorerRoute = AppAutomotiveExplorerRouteImport.update({
  id: '/automotive/explorer',
  path: '/automotive/explorer',
  getParentRoute: () => AppRoute,
} as any)
const AppAutomotiveBotRoute = AppAutomotiveBotRouteImport.update({
  id: '/automotive/bot',
  path: '/automotive/bot',
  getParentRoute: () => AppRoute,
} as any)
const AppAdminUsersRoute = AppAdminUsersRouteImport.update({
  id: '/users',
  path: '/users',
  getParentRoute: () => AppAdminRoute,
} as any)
const AppAdminSettingsRoute = AppAdminSettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => AppAdminRoute,
} as any)
const AppAdminPlaygroundNodesRoute = AppAdminPlaygroundNodesRouteImport.update({
  id: '/playground-nodes',
  path: '/playground-nodes',
  getParentRoute: () => AppAdminRoute,
} as any)
const AppAdminK8sRoute = AppAdminK8sRouteImport.update({
  id: '/k8s',
  path: '/k8s',
  getParentRoute: () => AppAdminRoute,
} as any)
const AppAdminFlowTemplatesRoute = AppAdminFlowTemplatesRouteImport.update({
  id: '/flow-templates',
  path: '/flow-templates',
  getParentRoute: () => AppAdminRoute,
} as any)
const AppAdminCustomersRoute = AppAdminCustomersRouteImport.update({
  id: '/customers',
  path: '/customers',
  getParentRoute: () => AppAdminRoute,
} as any)
const AppAdminAuditRoute = AppAdminAuditRouteImport.update({
  id: '/audit',
  path: '/audit',
  getParentRoute: () => AppAdminRoute,
} as any)
const AppAdminActivityUsersRoute = AppAdminActivityUsersRouteImport.update({
  id: '/activity-users',
  path: '/activity-users',
  getParentRoute: () => AppAdminRoute,
} as any)
const AppAdminActivityPagesRoute = AppAdminActivityPagesRouteImport.update({
  id: '/activity-pages',
  path: '/activity-pages',
  getParentRoute: () => AppAdminRoute,
} as any)
const AppAdminActivityExternalLinksRoute =
  AppAdminActivityExternalLinksRouteImport.update({
    id: '/activity-external-links',
    path: '/activity-external-links',
    getParentRoute: () => AppAdminRoute,
  } as any)
const AppAdminActivityRoute = AppAdminActivityRouteImport.update({
  id: '/activity',
  path: '/activity',
  getParentRoute: () => AppAdminRoute,
} as any)

export interface FileRoutesByFullPath {
  '/applicationflow': typeof ApplicationflowRoute
  '/applicationintro': typeof ApplicationintroRoute
  '/applicationuns': typeof ApplicationunsRoute
  '/car': typeof CarRoute
  '/configuration': typeof ConfigurationRoute
  '/dhhome': typeof DhhomeRoute
  '/hivemqdatahub': typeof HivemqdatahubRoute
  '/home': typeof HomeRoute
  '/introslides': typeof IntroslidesRoute
  '/licensingslides': typeof LicensingslidesRoute
  '/login': typeof LoginRoute
  '/showconfiguration': typeof ShowconfigurationRoute
  '/showinfos': typeof ShowinfosRoute
  '/admin': typeof AppAdminRouteWithChildren
  '/datahub': typeof AppDatahubRoute
  '/demoinfo': typeof AppDemoinfoRoute
  '/dhanonymizeflow': typeof AppDhanonymizeflowRoute
  '/dhftocflow': typeof AppDhftocflowRoute
  '/dhgeolocationflow': typeof AppDhgeolocationflowRoute
  '/dhsparkplugfanoutflow': typeof AppDhsparkplugfanoutflowRoute
  '/hivemqagentic': typeof AppHivemqagenticRoute
  '/hivemqedge': typeof AppHivemqedgeRoute
  '/hivemqintro': typeof AppHivemqintroRoute
  '/hivemqpilars': typeof AppHivemqpilarsRoute
  '/hivemqvision': typeof AppHivemqvisionRoute
  '/mqtt-client': typeof AppMqttClientRoute
  '/playground': typeof AppPlaygroundRoute
  '/pulse': typeof AppPulseRoute
  '/valuespace': typeof AppValuespaceRoute
  '/login/callback': typeof LoginCallbackRoute
  '/s/$shortCode': typeof SShortCodeRoute
  '/': typeof AppIndexRoute
  '/admin/activity': typeof AppAdminActivityRoute
  '/admin/activity-external-links': typeof AppAdminActivityExternalLinksRoute
  '/admin/activity-pages': typeof AppAdminActivityPagesRoute
  '/admin/activity-users': typeof AppAdminActivityUsersRoute
  '/admin/audit': typeof AppAdminAuditRoute
  '/admin/customers': typeof AppAdminCustomersRoute
  '/admin/flow-templates': typeof AppAdminFlowTemplatesRoute
  '/admin/k8s': typeof AppAdminK8sRoute
  '/admin/playground-nodes': typeof AppAdminPlaygroundNodesRoute
  '/admin/settings': typeof AppAdminSettingsRoute
  '/admin/users': typeof AppAdminUsersRoute
  '/automotive/bot': typeof AppAutomotiveBotRoute
  '/automotive/explorer': typeof AppAutomotiveExplorerRoute
  '/automotive/flow': typeof AppAutomotiveFlowRoute
  '/automotive/knowledge-graph': typeof AppAutomotiveKnowledgeGraphRoute
  '/business-value/data-centers': typeof AppBusinessValueDataCentersRoute
  '/business-value/energy': typeof AppBusinessValueEnergyRoute
  '/business-value/logistics': typeof AppBusinessValueLogisticsRoute
  '/business-value/smart-manufacturing': typeof AppBusinessValueSmartManufacturingRoute
  '/connected/bot': typeof AppConnectedBotRoute
  '/connected/explorer': typeof AppConnectedExplorerRoute
  '/connected/flow': typeof AppConnectedFlowRoute
  '/connected/knowledge-graph': typeof AppConnectedKnowledgeGraphRoute
  '/connected/tracing': typeof AppConnectedTracingRoute
  '/customers/$slug': typeof AppCustomersSlugRoute
  '/datacenter/bot': typeof AppDatacenterBotRoute
  '/datacenter/explorer': typeof AppDatacenterExplorerRoute
  '/datacenter/flow': typeof AppDatacenterFlowRoute
  '/datacenter/knowledge-graph': typeof AppDatacenterKnowledgeGraphRoute
  '/datacenter/multisiteflow': typeof AppDatacenterMultisiteflowRoute
  '/education/hivemq-cluster': typeof AppEducationHivemqClusterRoute
  '/education/mqtt': typeof AppEducationMqttRoute
  '/education/sparkplug': typeof AppEducationSparkplugRoute
  '/education/tls-mtls': typeof AppEducationTlsMtlsRoute
  '/education/uns': typeof AppEducationUnsRoute
  '/energy/bot': typeof AppEnergyBotRoute
  '/energy/explorer': typeof AppEnergyExplorerRoute
  '/energy/flow': typeof AppEnergyFlowRoute
  '/energy/knowledge-graph': typeof AppEnergyKnowledgeGraphRoute
  '/factory/advancedflow': typeof AppFactoryAdvancedflowRoute
  '/factory/bot': typeof AppFactoryBotRoute
  '/factory/explorer': typeof AppFactoryExplorerRoute
  '/factory/flow': typeof AppFactoryFlowRoute
  '/factory/knowledge-graph': typeof AppFactoryKnowledgeGraphRoute
  '/factory/line': typeof AppFactoryLineRoute
  '/factory/multisiteflow': typeof AppFactoryMultisiteflowRoute
  '/logistics/bot': typeof AppLogisticsBotRoute
  '/logistics/explorer': typeof AppLogisticsExplorerRoute
  '/logistics/flow': typeof AppLogisticsFlowRoute
  '/logistics/knowledge-graph': typeof AppLogisticsKnowledgeGraphRoute
  '/oilandgas/bot': typeof AppOilandgasBotRoute
  '/oilandgas/explorer': typeof AppOilandgasExplorerRoute
  '/oilandgas/flow': typeof AppOilandgasFlowRoute
  '/oilandgas/knowledge-graph': typeof AppOilandgasKnowledgeGraphRoute
  '/pharma/bot': typeof AppPharmaBotRoute
  '/pharma/explorer': typeof AppPharmaExplorerRoute
  '/pharma/flow': typeof AppPharmaFlowRoute
  '/pharma/knowledge-graph': typeof AppPharmaKnowledgeGraphRoute
  '/automotive': typeof AppAutomotiveIndexRoute
  '/business-value': typeof AppBusinessValueIndexRoute
  '/connected': typeof AppConnectedIndexRoute
  '/datacenter': typeof AppDatacenterIndexRoute
  '/education': typeof AppEducationIndexRoute
  '/energy': typeof AppEnergyIndexRoute
  '/factory': typeof AppFactoryIndexRoute
  '/logistics': typeof AppLogisticsIndexRoute
  '/oilandgas': typeof AppOilandgasIndexRoute
  '/pharma': typeof AppPharmaIndexRoute
}
export interface FileRoutesByTo {
  '/applicationflow': typeof ApplicationflowRoute
  '/applicationintro': typeof ApplicationintroRoute
  '/applicationuns': typeof ApplicationunsRoute
  '/car': typeof CarRoute
  '/configuration': typeof ConfigurationRoute
  '/dhhome': typeof DhhomeRoute
  '/hivemqdatahub': typeof HivemqdatahubRoute
  '/home': typeof HomeRoute
  '/introslides': typeof IntroslidesRoute
  '/licensingslides': typeof LicensingslidesRoute
  '/login': typeof LoginRoute
  '/showconfiguration': typeof ShowconfigurationRoute
  '/showinfos': typeof ShowinfosRoute
  '/admin': typeof AppAdminRouteWithChildren
  '/datahub': typeof AppDatahubRoute
  '/demoinfo': typeof AppDemoinfoRoute
  '/dhanonymizeflow': typeof AppDhanonymizeflowRoute
  '/dhftocflow': typeof AppDhftocflowRoute
  '/dhgeolocationflow': typeof AppDhgeolocationflowRoute
  '/dhsparkplugfanoutflow': typeof AppDhsparkplugfanoutflowRoute
  '/hivemqagentic': typeof AppHivemqagenticRoute
  '/hivemqedge': typeof AppHivemqedgeRoute
  '/hivemqintro': typeof AppHivemqintroRoute
  '/hivemqpilars': typeof AppHivemqpilarsRoute
  '/hivemqvision': typeof AppHivemqvisionRoute
  '/mqtt-client': typeof AppMqttClientRoute
  '/playground': typeof AppPlaygroundRoute
  '/pulse': typeof AppPulseRoute
  '/valuespace': typeof AppValuespaceRoute
  '/login/callback': typeof LoginCallbackRoute
  '/s/$shortCode': typeof SShortCodeRoute
  '/': typeof AppIndexRoute
  '/admin/activity': typeof AppAdminActivityRoute
  '/admin/activity-external-links': typeof AppAdminActivityExternalLinksRoute
  '/admin/activity-pages': typeof AppAdminActivityPagesRoute
  '/admin/activity-users': typeof AppAdminActivityUsersRoute
  '/admin/audit': typeof AppAdminAuditRoute
  '/admin/customers': typeof AppAdminCustomersRoute
  '/admin/flow-templates': typeof AppAdminFlowTemplatesRoute
  '/admin/k8s': typeof AppAdminK8sRoute
  '/admin/playground-nodes': typeof AppAdminPlaygroundNodesRoute
  '/admin/settings': typeof AppAdminSettingsRoute
  '/admin/users': typeof AppAdminUsersRoute
  '/automotive/bot': typeof AppAutomotiveBotRoute
  '/automotive/explorer': typeof AppAutomotiveExplorerRoute
  '/automotive/flow': typeof AppAutomotiveFlowRoute
  '/automotive/knowledge-graph': typeof AppAutomotiveKnowledgeGraphRoute
  '/business-value/data-centers': typeof AppBusinessValueDataCentersRoute
  '/business-value/energy': typeof AppBusinessValueEnergyRoute
  '/business-value/logistics': typeof AppBusinessValueLogisticsRoute
  '/business-value/smart-manufacturing': typeof AppBusinessValueSmartManufacturingRoute
  '/connected/bot': typeof AppConnectedBotRoute
  '/connected/explorer': typeof AppConnectedExplorerRoute
  '/connected/flow': typeof AppConnectedFlowRoute
  '/connected/knowledge-graph': typeof AppConnectedKnowledgeGraphRoute
  '/connected/tracing': typeof AppConnectedTracingRoute
  '/customers/$slug': typeof AppCustomersSlugRoute
  '/datacenter/bot': typeof AppDatacenterBotRoute
  '/datacenter/explorer': typeof AppDatacenterExplorerRoute
  '/datacenter/flow': typeof AppDatacenterFlowRoute
  '/datacenter/knowledge-graph': typeof AppDatacenterKnowledgeGraphRoute
  '/datacenter/multisiteflow': typeof AppDatacenterMultisiteflowRoute
  '/education/hivemq-cluster': typeof AppEducationHivemqClusterRoute
  '/education/mqtt': typeof AppEducationMqttRoute
  '/education/sparkplug': typeof AppEducationSparkplugRoute
  '/education/tls-mtls': typeof AppEducationTlsMtlsRoute
  '/education/uns': typeof AppEducationUnsRoute
  '/energy/bot': typeof AppEnergyBotRoute
  '/energy/explorer': typeof AppEnergyExplorerRoute
  '/energy/flow': typeof AppEnergyFlowRoute
  '/energy/knowledge-graph': typeof AppEnergyKnowledgeGraphRoute
  '/factory/advancedflow': typeof AppFactoryAdvancedflowRoute
  '/factory/bot': typeof AppFactoryBotRoute
  '/factory/explorer': typeof AppFactoryExplorerRoute
  '/factory/flow': typeof AppFactoryFlowRoute
  '/factory/knowledge-graph': typeof AppFactoryKnowledgeGraphRoute
  '/factory/line': typeof AppFactoryLineRoute
  '/factory/multisiteflow': typeof AppFactoryMultisiteflowRoute
  '/logistics/bot': typeof AppLogisticsBotRoute
  '/logistics/explorer': typeof AppLogisticsExplorerRoute
  '/logistics/flow': typeof AppLogisticsFlowRoute
  '/logistics/knowledge-graph': typeof AppLogisticsKnowledgeGraphRoute
  '/oilandgas/bot': typeof AppOilandgasBotRoute
  '/oilandgas/explorer': typeof AppOilandgasExplorerRoute
  '/oilandgas/flow': typeof AppOilandgasFlowRoute
  '/oilandgas/knowledge-graph': typeof AppOilandgasKnowledgeGraphRoute
  '/pharma/bot': typeof AppPharmaBotRoute
  '/pharma/explorer': typeof AppPharmaExplorerRoute
  '/pharma/flow': typeof AppPharmaFlowRoute
  '/pharma/knowledge-graph': typeof AppPharmaKnowledgeGraphRoute
  '/automotive': typeof AppAutomotiveIndexRoute
  '/business-value': typeof AppBusinessValueIndexRoute
  '/connected': typeof AppConnectedIndexRoute
  '/datacenter': typeof AppDatacenterIndexRoute
  '/education': typeof AppEducationIndexRoute
  '/energy': typeof AppEnergyIndexRoute
  '/factory': typeof AppFactoryIndexRoute
  '/logistics': typeof AppLogisticsIndexRoute
  '/oilandgas': typeof AppOilandgasIndexRoute
  '/pharma': typeof AppPharmaIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_app': typeof AppRouteWithChildren
  '/applicationflow': typeof ApplicationflowRoute
  '/applicationintro': typeof ApplicationintroRoute
  '/applicationuns': typeof ApplicationunsRoute
  '/car': typeof CarRoute
  '/configuration': typeof ConfigurationRoute
  '/dhhome': typeof DhhomeRoute
  '/hivemqdatahub': typeof HivemqdatahubRoute
  '/home': typeof HomeRoute
  '/introslides': typeof IntroslidesRoute
  '/licensingslides': typeof LicensingslidesRoute
  '/login': typeof LoginRoute
  '/showconfiguration': typeof ShowconfigurationRoute
  '/showinfos': typeof ShowinfosRoute
  '/_app/admin': typeof AppAdminRouteWithChildren
  '/_app/datahub': typeof AppDatahubRoute
  '/_app/demoinfo': typeof AppDemoinfoRoute
  '/_app/dhanonymizeflow': typeof AppDhanonymizeflowRoute
  '/_app/dhftocflow': typeof AppDhftocflowRoute
  '/_app/dhgeolocationflow': typeof AppDhgeolocationflowRoute
  '/_app/dhsparkplugfanoutflow': typeof AppDhsparkplugfanoutflowRoute
  '/_app/hivemqagentic': typeof AppHivemqagenticRoute
  '/_app/hivemqedge': typeof AppHivemqedgeRoute
  '/_app/hivemqintro': typeof AppHivemqintroRoute
  '/_app/hivemqpilars': typeof AppHivemqpilarsRoute
  '/_app/hivemqvision': typeof AppHivemqvisionRoute
  '/_app/mqtt-client': typeof AppMqttClientRoute
  '/_app/playground': typeof AppPlaygroundRoute
  '/_app/pulse': typeof AppPulseRoute
  '/_app/valuespace': typeof AppValuespaceRoute
  '/login_/callback': typeof LoginCallbackRoute
  '/s/$shortCode': typeof SShortCodeRoute
  '/_app/': typeof AppIndexRoute
  '/_app/admin/activity': typeof AppAdminActivityRoute
  '/_app/admin/activity-external-links': typeof AppAdminActivityExternalLinksRoute
  '/_app/admin/activity-pages': typeof AppAdminActivityPagesRoute
  '/_app/admin/activity-users': typeof AppAdminActivityUsersRoute
  '/_app/admin/audit': typeof AppAdminAuditRoute
  '/_app/admin/customers': typeof AppAdminCustomersRoute
  '/_app/admin/flow-templates': typeof AppAdminFlowTemplatesRoute
  '/_app/admin/k8s': typeof AppAdminK8sRoute
  '/_app/admin/playground-nodes': typeof AppAdminPlaygroundNodesRoute
  '/_app/admin/settings': typeof AppAdminSettingsRoute
  '/_app/admin/users': typeof AppAdminUsersRoute
  '/_app/automotive/bot': typeof AppAutomotiveBotRoute
  '/_app/automotive/explorer': typeof AppAutomotiveExplorerRoute
  '/_app/automotive/flow': typeof AppAutomotiveFlowRoute
  '/_app/automotive/knowledge-graph': typeof AppAutomotiveKnowledgeGraphRoute
  '/_app/business-value/data-centers': typeof AppBusinessValueDataCentersRoute
  '/_app/business-value/energy': typeof AppBusinessValueEnergyRoute
  '/_app/business-value/logistics': typeof AppBusinessValueLogisticsRoute
  '/_app/business-value/smart-manufacturing': typeof AppBusinessValueSmartManufacturingRoute
  '/_app/connected/bot': typeof AppConnectedBotRoute
  '/_app/connected/explorer': typeof AppConnectedExplorerRoute
  '/_app/connected/flow': typeof AppConnectedFlowRoute
  '/_app/connected/knowledge-graph': typeof AppConnectedKnowledgeGraphRoute
  '/_app/connected/tracing': typeof AppConnectedTracingRoute
  '/_app/customers/$slug': typeof AppCustomersSlugRoute
  '/_app/datacenter/bot': typeof AppDatacenterBotRoute
  '/_app/datacenter/explorer': typeof AppDatacenterExplorerRoute
  '/_app/datacenter/flow': typeof AppDatacenterFlowRoute
  '/_app/datacenter/knowledge-graph': typeof AppDatacenterKnowledgeGraphRoute
  '/_app/datacenter/multisiteflow': typeof AppDatacenterMultisiteflowRoute
  '/_app/education/hivemq-cluster': typeof AppEducationHivemqClusterRoute
  '/_app/education/mqtt': typeof AppEducationMqttRoute
  '/_app/education/sparkplug': typeof AppEducationSparkplugRoute
  '/_app/education/tls-mtls': typeof AppEducationTlsMtlsRoute
  '/_app/education/uns': typeof AppEducationUnsRoute
  '/_app/energy/bot': typeof AppEnergyBotRoute
  '/_app/energy/explorer': typeof AppEnergyExplorerRoute
  '/_app/energy/flow': typeof AppEnergyFlowRoute
  '/_app/energy/knowledge-graph': typeof AppEnergyKnowledgeGraphRoute
  '/_app/factory/advancedflow': typeof AppFactoryAdvancedflowRoute
  '/_app/factory/bot': typeof AppFactoryBotRoute
  '/_app/factory/explorer': typeof AppFactoryExplorerRoute
  '/_app/factory/flow': typeof AppFactoryFlowRoute
  '/_app/factory/knowledge-graph': typeof AppFactoryKnowledgeGraphRoute
  '/_app/factory/line': typeof AppFactoryLineRoute
  '/_app/factory/multisiteflow': typeof AppFactoryMultisiteflowRoute
  '/_app/logistics/bot': typeof AppLogisticsBotRoute
  '/_app/logistics/explorer': typeof AppLogisticsExplorerRoute
  '/_app/logistics/flow': typeof AppLogisticsFlowRoute
  '/_app/logistics/knowledge-graph': typeof AppLogisticsKnowledgeGraphRoute
  '/_app/oilandgas/bot': typeof AppOilandgasBotRoute
  '/_app/oilandgas/explorer': typeof AppOilandgasExplorerRoute
  '/_app/oilandgas/flow': typeof AppOilandgasFlowRoute
  '/_app/oilandgas/knowledge-graph': typeof AppOilandgasKnowledgeGraphRoute
  '/_app/pharma/bot': typeof AppPharmaBotRoute
  '/_app/pharma/explorer': typeof AppPharmaExplorerRoute
  '/_app/pharma/flow': typeof AppPharmaFlowRoute
  '/_app/pharma/knowledge-graph': typeof AppPharmaKnowledgeGraphRoute
  '/_app/automotive/': typeof AppAutomotiveIndexRoute
  '/_app/business-value/': typeof AppBusinessValueIndexRoute
  '/_app/connected/': typeof AppConnectedIndexRoute
  '/_app/datacenter/': typeof AppDatacenterIndexRoute
  '/_app/education/': typeof AppEducationIndexRoute
  '/_app/energy/': typeof AppEnergyIndexRoute
  '/_app/factory/': typeof AppFactoryIndexRoute
  '/_app/logistics/': typeof AppLogisticsIndexRoute
  '/_app/oilandgas/': typeof AppOilandgasIndexRoute
  '/_app/pharma/': typeof AppPharmaIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/applicationflow'
    | '/applicationintro'
    | '/applicationuns'
    | '/car'
    | '/configuration'
    | '/dhhome'
    | '/hivemqdatahub'
    | '/home'
    | '/introslides'
    | '/licensingslides'
    | '/login'
    | '/showconfiguration'
    | '/showinfos'
    | '/admin'
    | '/datahub'
    | '/demoinfo'
    | '/dhanonymizeflow'
    | '/dhftocflow'
    | '/dhgeolocationflow'
    | '/dhsparkplugfanoutflow'
    | '/hivemqagentic'
    | '/hivemqedge'
    | '/hivemqintro'
    | '/hivemqpilars'
    | '/hivemqvision'
    | '/mqtt-client'
    | '/playground'
    | '/pulse'
    | '/valuespace'
    | '/login/callback'
    | '/s/$shortCode'
    | '/'
    | '/admin/activity'
    | '/admin/activity-external-links'
    | '/admin/activity-pages'
    | '/admin/activity-users'
    | '/admin/audit'
    | '/admin/customers'
    | '/admin/flow-templates'
    | '/admin/k8s'
    | '/admin/playground-nodes'
    | '/admin/settings'
    | '/admin/users'
    | '/automotive/bot'
    | '/automotive/explorer'
    | '/automotive/flow'
    | '/automotive/knowledge-graph'
    | '/business-value/data-centers'
    | '/business-value/energy'
    | '/business-value/logistics'
    | '/business-value/smart-manufacturing'
    | '/connected/bot'
    | '/connected/explorer'
    | '/connected/flow'
    | '/connected/knowledge-graph'
    | '/connected/tracing'
    | '/customers/$slug'
    | '/datacenter/bot'
    | '/datacenter/explorer'
    | '/datacenter/flow'
    | '/datacenter/knowledge-graph'
    | '/datacenter/multisiteflow'
    | '/education/hivemq-cluster'
    | '/education/mqtt'
    | '/education/sparkplug'
    | '/education/tls-mtls'
    | '/education/uns'
    | '/energy/bot'
    | '/energy/explorer'
    | '/energy/flow'
    | '/energy/knowledge-graph'
    | '/factory/advancedflow'
    | '/factory/bot'
    | '/factory/explorer'
    | '/factory/flow'
    | '/factory/knowledge-graph'
    | '/factory/line'
    | '/factory/multisiteflow'
    | '/logistics/bot'
    | '/logistics/explorer'
    | '/logistics/flow'
    | '/logistics/knowledge-graph'
    | '/oilandgas/bot'
    | '/oilandgas/explorer'
    | '/oilandgas/flow'
    | '/oilandgas/knowledge-graph'
    | '/pharma/bot'
    | '/pharma/explorer'
    | '/pharma/flow'
    | '/pharma/knowledge-graph'
    | '/automotive'
    | '/business-value'
    | '/connected'
    | '/datacenter'
    | '/education'
    | '/energy'
    | '/factory'
    | '/logistics'
    | '/oilandgas'
    | '/pharma'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/applicationflow'
    | '/applicationintro'
    | '/applicationuns'
    | '/car'
    | '/configuration'
    | '/dhhome'
    | '/hivemqdatahub'
    | '/home'
    | '/introslides'
    | '/licensingslides'
    | '/login'
    | '/showconfiguration'
    | '/showinfos'
    | '/admin'
    | '/datahub'
    | '/demoinfo'
    | '/dhanonymizeflow'
    | '/dhftocflow'
    | '/dhgeolocationflow'
    | '/dhsparkplugfanoutflow'
    | '/hivemqagentic'
    | '/hivemqedge'
    | '/hivemqintro'
    | '/hivemqpilars'
    | '/hivemqvision'
    | '/mqtt-client'
    | '/playground'
    | '/pulse'
    | '/valuespace'
    | '/login/callback'
    | '/s/$shortCode'
    | '/'
    | '/admin/activity'
    | '/admin/activity-external-links'
    | '/admin/activity-pages'
    | '/admin/activity-users'
    | '/admin/audit'
    | '/admin/customers'
    | '/admin/flow-templates'
    | '/admin/k8s'
    | '/admin/playground-nodes'
    | '/admin/settings'
    | '/admin/users'
    | '/automotive/bot'
    | '/automotive/explorer'
    | '/automotive/flow'
    | '/automotive/knowledge-graph'
    | '/business-value/data-centers'
    | '/business-value/energy'
    | '/business-value/logistics'
    | '/business-value/smart-manufacturing'
    | '/connected/bot'
    | '/connected/explorer'
    | '/connected/flow'
    | '/connected/knowledge-graph'
    | '/connected/tracing'
    | '/customers/$slug'
    | '/datacenter/bot'
    | '/datacenter/explorer'
    | '/datacenter/flow'
    | '/datacenter/knowledge-graph'
    | '/datacenter/multisiteflow'
    | '/education/hivemq-cluster'
    | '/education/mqtt'
    | '/education/sparkplug'
    | '/education/tls-mtls'
    | '/education/uns'
    | '/energy/bot'
    | '/energy/explorer'
    | '/energy/flow'
    | '/energy/knowledge-graph'
    | '/factory/advancedflow'
    | '/factory/bot'
    | '/factory/explorer'
    | '/factory/flow'
    | '/factory/knowledge-graph'
    | '/factory/line'
    | '/factory/multisiteflow'
    | '/logistics/bot'
    | '/logistics/explorer'
    | '/logistics/flow'
    | '/logistics/knowledge-graph'
    | '/oilandgas/bot'
    | '/oilandgas/explorer'
    | '/oilandgas/flow'
    | '/oilandgas/knowledge-graph'
    | '/pharma/bot'
    | '/pharma/explorer'
    | '/pharma/flow'
    | '/pharma/knowledge-graph'
    | '/automotive'
    | '/business-value'
    | '/connected'
    | '/datacenter'
    | '/education'
    | '/energy'
    | '/factory'
    | '/logistics'
    | '/oilandgas'
    | '/pharma'
  id:
    | '__root__'
    | '/_app'
    | '/applicationflow'
    | '/applicationintro'
    | '/applicationuns'
    | '/car'
    | '/configuration'
    | '/dhhome'
    | '/hivemqdatahub'
    | '/home'
    | '/introslides'
    | '/licensingslides'
    | '/login'
    | '/showconfiguration'
    | '/showinfos'
    | '/_app/admin'
    | '/_app/datahub'
    | '/_app/demoinfo'
    | '/_app/dhanonymizeflow'
    | '/_app/dhftocflow'
    | '/_app/dhgeolocationflow'
    | '/_app/dhsparkplugfanoutflow'
    | '/_app/hivemqagentic'
    | '/_app/hivemqedge'
    | '/_app/hivemqintro'
    | '/_app/hivemqpilars'
    | '/_app/hivemqvision'
    | '/_app/mqtt-client'
    | '/_app/playground'
    | '/_app/pulse'
    | '/_app/valuespace'
    | '/login_/callback'
    | '/s/$shortCode'
    | '/_app/'
    | '/_app/admin/activity'
    | '/_app/admin/activity-external-links'
    | '/_app/admin/activity-pages'
    | '/_app/admin/activity-users'
    | '/_app/admin/audit'
    | '/_app/admin/customers'
    | '/_app/admin/flow-templates'
    | '/_app/admin/k8s'
    | '/_app/admin/playground-nodes'
    | '/_app/admin/settings'
    | '/_app/admin/users'
    | '/_app/automotive/bot'
    | '/_app/automotive/explorer'
    | '/_app/automotive/flow'
    | '/_app/automotive/knowledge-graph'
    | '/_app/business-value/data-centers'
    | '/_app/business-value/energy'
    | '/_app/business-value/logistics'
    | '/_app/business-value/smart-manufacturing'
    | '/_app/connected/bot'
    | '/_app/connected/explorer'
    | '/_app/connected/flow'
    | '/_app/connected/knowledge-graph'
    | '/_app/connected/tracing'
    | '/_app/customers/$slug'
    | '/_app/datacenter/bot'
    | '/_app/datacenter/explorer'
    | '/_app/datacenter/flow'
    | '/_app/datacenter/knowledge-graph'
    | '/_app/datacenter/multisiteflow'
    | '/_app/education/hivemq-cluster'
    | '/_app/education/mqtt'
    | '/_app/education/sparkplug'
    | '/_app/education/tls-mtls'
    | '/_app/education/uns'
    | '/_app/energy/bot'
    | '/_app/energy/explorer'
    | '/_app/energy/flow'
    | '/_app/energy/knowledge-graph'
    | '/_app/factory/advancedflow'
    | '/_app/factory/bot'
    | '/_app/factory/explorer'
    | '/_app/factory/flow'
    | '/_app/factory/knowledge-graph'
    | '/_app/factory/line'
    | '/_app/factory/multisiteflow'
    | '/_app/logistics/bot'
    | '/_app/logistics/explorer'
    | '/_app/logistics/flow'
    | '/_app/logistics/knowledge-graph'
    | '/_app/oilandgas/bot'
    | '/_app/oilandgas/explorer'
    | '/_app/oilandgas/flow'
    | '/_app/oilandgas/knowledge-graph'
    | '/_app/pharma/bot'
    | '/_app/pharma/explorer'
    | '/_app/pharma/flow'
    | '/_app/pharma/knowledge-graph'
    | '/_app/automotive/'
    | '/_app/business-value/'
    | '/_app/connected/'
    | '/_app/datacenter/'
    | '/_app/education/'
    | '/_app/energy/'
    | '/_app/factory/'
    | '/_app/logistics/'
    | '/_app/oilandgas/'
    | '/_app/pharma/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AppRoute: typeof AppRouteWithChildren
  ApplicationflowRoute: typeof ApplicationflowRoute
  ApplicationintroRoute: typeof ApplicationintroRoute
  ApplicationunsRoute: typeof ApplicationunsRoute
  CarRoute: typeof CarRoute
  ConfigurationRoute: typeof ConfigurationRoute
  DhhomeRoute: typeof DhhomeRoute
  HivemqdatahubRoute: typeof HivemqdatahubRoute
  HomeRoute: typeof HomeRoute
  IntroslidesRoute: typeof IntroslidesRoute
  LicensingslidesRoute: typeof LicensingslidesRoute
  LoginRoute: typeof LoginRoute
  ShowconfigurationRoute: typeof ShowconfigurationRoute
  ShowinfosRoute: typeof ShowinfosRoute
  LoginCallbackRoute: typeof LoginCallbackRoute
  SShortCodeRoute: typeof SShortCodeRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/showinfos': {
      id: '/showinfos'
      path: '/showinfos'
      fullPath: '/showinfos'
      preLoaderRoute: typeof ShowinfosRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/showconfiguration': {
      id: '/showconfiguration'
      path: '/showconfiguration'
      fullPath: '/showconfiguration'
      preLoaderRoute: typeof ShowconfigurationRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/licensingslides': {
      id: '/licensingslides'
      path: '/licensingslides'
      fullPath: '/licensingslides'
      preLoaderRoute: typeof LicensingslidesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/introslides': {
      id: '/introslides'
      path: '/introslides'
      fullPath: '/introslides'
      preLoaderRoute: typeof IntroslidesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/home': {
      id: '/home'
      path: '/home'
      fullPath: '/home'
      preLoaderRoute: typeof HomeRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/hivemqdatahub': {
      id: '/hivemqdatahub'
      path: '/hivemqdatahub'
      fullPath: '/hivemqdatahub'
      preLoaderRoute: typeof HivemqdatahubRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/dhhome': {
      id: '/dhhome'
      path: '/dhhome'
      fullPath: '/dhhome'
      preLoaderRoute: typeof DhhomeRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/configuration': {
      id: '/configuration'
      path: '/configuration'
      fullPath: '/configuration'
      preLoaderRoute: typeof ConfigurationRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/car': {
      id: '/car'
      path: '/car'
      fullPath: '/car'
      preLoaderRoute: typeof CarRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/applicationuns': {
      id: '/applicationuns'
      path: '/applicationuns'
      fullPath: '/applicationuns'
      preLoaderRoute: typeof ApplicationunsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/applicationintro': {
      id: '/applicationintro'
      path: '/applicationintro'
      fullPath: '/applicationintro'
      preLoaderRoute: typeof ApplicationintroRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/applicationflow': {
      id: '/applicationflow'
      path: '/applicationflow'
      fullPath: '/applicationflow'
      preLoaderRoute: typeof ApplicationflowRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app': {
      id: '/_app'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof AppRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/': {
      id: '/_app/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AppIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/s/$shortCode': {
      id: '/s/$shortCode'
      path: '/s/$shortCode'
      fullPath: '/s/$shortCode'
      preLoaderRoute: typeof SShortCodeRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login_/callback': {
      id: '/login_/callback'
      path: '/login/callback'
      fullPath: '/login/callback'
      preLoaderRoute: typeof LoginCallbackRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/valuespace': {
      id: '/_app/valuespace'
      path: '/valuespace'
      fullPath: '/valuespace'
      preLoaderRoute: typeof AppValuespaceRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/pulse': {
      id: '/_app/pulse'
      path: '/pulse'
      fullPath: '/pulse'
      preLoaderRoute: typeof AppPulseRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/playground': {
      id: '/_app/playground'
      path: '/playground'
      fullPath: '/playground'
      preLoaderRoute: typeof AppPlaygroundRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/mqtt-client': {
      id: '/_app/mqtt-client'
      path: '/mqtt-client'
      fullPath: '/mqtt-client'
      preLoaderRoute: typeof AppMqttClientRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/hivemqvision': {
      id: '/_app/hivemqvision'
      path: '/hivemqvision'
      fullPath: '/hivemqvision'
      preLoaderRoute: typeof AppHivemqvisionRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/hivemqpilars': {
      id: '/_app/hivemqpilars'
      path: '/hivemqpilars'
      fullPath: '/hivemqpilars'
      preLoaderRoute: typeof AppHivemqpilarsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/hivemqintro': {
      id: '/_app/hivemqintro'
      path: '/hivemqintro'
      fullPath: '/hivemqintro'
      preLoaderRoute: typeof AppHivemqintroRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/hivemqedge': {
      id: '/_app/hivemqedge'
      path: '/hivemqedge'
      fullPath: '/hivemqedge'
      preLoaderRoute: typeof AppHivemqedgeRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/hivemqagentic': {
      id: '/_app/hivemqagentic'
      path: '/hivemqagentic'
      fullPath: '/hivemqagentic'
      preLoaderRoute: typeof AppHivemqagenticRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/dhsparkplugfanoutflow': {
      id: '/_app/dhsparkplugfanoutflow'
      path: '/dhsparkplugfanoutflow'
      fullPath: '/dhsparkplugfanoutflow'
      preLoaderRoute: typeof AppDhsparkplugfanoutflowRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/dhgeolocationflow': {
      id: '/_app/dhgeolocationflow'
      path: '/dhgeolocationflow'
      fullPath: '/dhgeolocationflow'
      preLoaderRoute: typeof AppDhgeolocationflowRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/dhftocflow': {
      id: '/_app/dhftocflow'
      path: '/dhftocflow'
      fullPath: '/dhftocflow'
      preLoaderRoute: typeof AppDhftocflowRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/dhanonymizeflow': {
      id: '/_app/dhanonymizeflow'
      path: '/dhanonymizeflow'
      fullPath: '/dhanonymizeflow'
      preLoaderRoute: typeof AppDhanonymizeflowRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/demoinfo': {
      id: '/_app/demoinfo'
      path: '/demoinfo'
      fullPath: '/demoinfo'
      preLoaderRoute: typeof AppDemoinfoRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/datahub': {
      id: '/_app/datahub'
      path: '/datahub'
      fullPath: '/datahub'
      preLoaderRoute: typeof AppDatahubRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/admin': {
      id: '/_app/admin'
      path: '/admin'
      fullPath: '/admin'
      preLoaderRoute: typeof AppAdminRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/pharma/': {
      id: '/_app/pharma/'
      path: '/pharma'
      fullPath: '/pharma'
      preLoaderRoute: typeof AppPharmaIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/oilandgas/': {
      id: '/_app/oilandgas/'
      path: '/oilandgas'
      fullPath: '/oilandgas'
      preLoaderRoute: typeof AppOilandgasIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/logistics/': {
      id: '/_app/logistics/'
      path: '/logistics'
      fullPath: '/logistics'
      preLoaderRoute: typeof AppLogisticsIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/factory/': {
      id: '/_app/factory/'
      path: '/factory'
      fullPath: '/factory'
      preLoaderRoute: typeof AppFactoryIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/energy/': {
      id: '/_app/energy/'
      path: '/energy'
      fullPath: '/energy'
      preLoaderRoute: typeof AppEnergyIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/education/': {
      id: '/_app/education/'
      path: '/education'
      fullPath: '/education'
      preLoaderRoute: typeof AppEducationIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/datacenter/': {
      id: '/_app/datacenter/'
      path: '/datacenter'
      fullPath: '/datacenter'
      preLoaderRoute: typeof AppDatacenterIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/connected/': {
      id: '/_app/connected/'
      path: '/connected'
      fullPath: '/connected'
      preLoaderRoute: typeof AppConnectedIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/business-value/': {
      id: '/_app/business-value/'
      path: '/business-value'
      fullPath: '/business-value'
      preLoaderRoute: typeof AppBusinessValueIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/automotive/': {
      id: '/_app/automotive/'
      path: '/automotive'
      fullPath: '/automotive'
      preLoaderRoute: typeof AppAutomotiveIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/pharma/knowledge-graph': {
      id: '/_app/pharma/knowledge-graph'
      path: '/pharma/knowledge-graph'
      fullPath: '/pharma/knowledge-graph'
      preLoaderRoute: typeof AppPharmaKnowledgeGraphRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/pharma/flow': {
      id: '/_app/pharma/flow'
      path: '/pharma/flow'
      fullPath: '/pharma/flow'
      preLoaderRoute: typeof AppPharmaFlowRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/pharma/explorer': {
      id: '/_app/pharma/explorer'
      path: '/pharma/explorer'
      fullPath: '/pharma/explorer'
      preLoaderRoute: typeof AppPharmaExplorerRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/pharma/bot': {
      id: '/_app/pharma/bot'
      path: '/pharma/bot'
      fullPath: '/pharma/bot'
      preLoaderRoute: typeof AppPharmaBotRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/oilandgas/knowledge-graph': {
      id: '/_app/oilandgas/knowledge-graph'
      path: '/oilandgas/knowledge-graph'
      fullPath: '/oilandgas/knowledge-graph'
      preLoaderRoute: typeof AppOilandgasKnowledgeGraphRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/oilandgas/flow': {
      id: '/_app/oilandgas/flow'
      path: '/oilandgas/flow'
      fullPath: '/oilandgas/flow'
      preLoaderRoute: typeof AppOilandgasFlowRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/oilandgas/explorer': {
      id: '/_app/oilandgas/explorer'
      path: '/oilandgas/explorer'
      fullPath: '/oilandgas/explorer'
      preLoaderRoute: typeof AppOilandgasExplorerRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/oilandgas/bot': {
      id: '/_app/oilandgas/bot'
      path: '/oilandgas/bot'
      fullPath: '/oilandgas/bot'
      preLoaderRoute: typeof AppOilandgasBotRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/logistics/knowledge-graph': {
      id: '/_app/logistics/knowledge-graph'
      path: '/logistics/knowledge-graph'
      fullPath: '/logistics/knowledge-graph'
      preLoaderRoute: typeof AppLogisticsKnowledgeGraphRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/logistics/flow': {
      id: '/_app/logistics/flow'
      path: '/logistics/flow'
      fullPath: '/logistics/flow'
      preLoaderRoute: typeof AppLogisticsFlowRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/logistics/explorer': {
      id: '/_app/logistics/explorer'
      path: '/logistics/explorer'
      fullPath: '/logistics/explorer'
      preLoaderRoute: typeof AppLogisticsExplorerRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/logistics/bot': {
      id: '/_app/logistics/bot'
      path: '/logistics/bot'
      fullPath: '/logistics/bot'
      preLoaderRoute: typeof AppLogisticsBotRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/factory/multisiteflow': {
      id: '/_app/factory/multisiteflow'
      path: '/factory/multisiteflow'
      fullPath: '/factory/multisiteflow'
      preLoaderRoute: typeof AppFactoryMultisiteflowRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/factory/line': {
      id: '/_app/factory/line'
      path: '/factory/line'
      fullPath: '/factory/line'
      preLoaderRoute: typeof AppFactoryLineRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/factory/knowledge-graph': {
      id: '/_app/factory/knowledge-graph'
      path: '/factory/knowledge-graph'
      fullPath: '/factory/knowledge-graph'
      preLoaderRoute: typeof AppFactoryKnowledgeGraphRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/factory/flow': {
      id: '/_app/factory/flow'
      path: '/factory/flow'
      fullPath: '/factory/flow'
      preLoaderRoute: typeof AppFactoryFlowRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/factory/explorer': {
      id: '/_app/factory/explorer'
      path: '/factory/explorer'
      fullPath: '/factory/explorer'
      preLoaderRoute: typeof AppFactoryExplorerRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/factory/bot': {
      id: '/_app/factory/bot'
      path: '/factory/bot'
      fullPath: '/factory/bot'
      preLoaderRoute: typeof AppFactoryBotRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/factory/advancedflow': {
      id: '/_app/factory/advancedflow'
      path: '/factory/advancedflow'
      fullPath: '/factory/advancedflow'
      preLoaderRoute: typeof AppFactoryAdvancedflowRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/energy/knowledge-graph': {
      id: '/_app/energy/knowledge-graph'
      path: '/energy/knowledge-graph'
      fullPath: '/energy/knowledge-graph'
      preLoaderRoute: typeof AppEnergyKnowledgeGraphRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/energy/flow': {
      id: '/_app/energy/flow'
      path: '/energy/flow'
      fullPath: '/energy/flow'
      preLoaderRoute: typeof AppEnergyFlowRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/energy/explorer': {
      id: '/_app/energy/explorer'
      path: '/energy/explorer'
      fullPath: '/energy/explorer'
      preLoaderRoute: typeof AppEnergyExplorerRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/energy/bot': {
      id: '/_app/energy/bot'
      path: '/energy/bot'
      fullPath: '/energy/bot'
      preLoaderRoute: typeof AppEnergyBotRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/education/uns': {
      id: '/_app/education/uns'
      path: '/education/uns'
      fullPath: '/education/uns'
      preLoaderRoute: typeof AppEducationUnsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/education/tls-mtls': {
      id: '/_app/education/tls-mtls'
      path: '/education/tls-mtls'
      fullPath: '/education/tls-mtls'
      preLoaderRoute: typeof AppEducationTlsMtlsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/education/sparkplug': {
      id: '/_app/education/sparkplug'
      path: '/education/sparkplug'
      fullPath: '/education/sparkplug'
      preLoaderRoute: typeof AppEducationSparkplugRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/education/mqtt': {
      id: '/_app/education/mqtt'
      path: '/education/mqtt'
      fullPath: '/education/mqtt'
      preLoaderRoute: typeof AppEducationMqttRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/education/hivemq-cluster': {
      id: '/_app/education/hivemq-cluster'
      path: '/education/hivemq-cluster'
      fullPath: '/education/hivemq-cluster'
      preLoaderRoute: typeof AppEducationHivemqClusterRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/datacenter/multisiteflow': {
      id: '/_app/datacenter/multisiteflow'
      path: '/datacenter/multisiteflow'
      fullPath: '/datacenter/multisiteflow'
      preLoaderRoute: typeof AppDatacenterMultisiteflowRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/datacenter/knowledge-graph': {
      id: '/_app/datacenter/knowledge-graph'
      path: '/datacenter/knowledge-graph'
      fullPath: '/datacenter/knowledge-graph'
      preLoaderRoute: typeof AppDatacenterKnowledgeGraphRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/datacenter/flow': {
      id: '/_app/datacenter/flow'
      path: '/datacenter/flow'
      fullPath: '/datacenter/flow'
      preLoaderRoute: typeof AppDatacenterFlowRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/datacenter/explorer': {
      id: '/_app/datacenter/explorer'
      path: '/datacenter/explorer'
      fullPath: '/datacenter/explorer'
      preLoaderRoute: typeof AppDatacenterExplorerRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/datacenter/bot': {
      id: '/_app/datacenter/bot'
      path: '/datacenter/bot'
      fullPath: '/datacenter/bot'
      preLoaderRoute: typeof AppDatacenterBotRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/customers/$slug': {
      id: '/_app/customers/$slug'
      path: '/customers/$slug'
      fullPath: '/customers/$slug'
      preLoaderRoute: typeof AppCustomersSlugRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/connected/tracing': {
      id: '/_app/connected/tracing'
      path: '/connected/tracing'
      fullPath: '/connected/tracing'
      preLoaderRoute: typeof AppConnectedTracingRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/connected/knowledge-graph': {
      id: '/_app/connected/knowledge-graph'
      path: '/connected/knowledge-graph'
      fullPath: '/connected/knowledge-graph'
      preLoaderRoute: typeof AppConnectedKnowledgeGraphRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/connected/flow': {
      id: '/_app/connected/flow'
      path: '/connected/flow'
      fullPath: '/connected/flow'
      preLoaderRoute: typeof AppConnectedFlowRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/connected/explorer': {
      id: '/_app/connected/explorer'
      path: '/connected/explorer'
      fullPath: '/connected/explorer'
      preLoaderRoute: typeof AppConnectedExplorerRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/connected/bot': {
      id: '/_app/connected/bot'
      path: '/connected/bot'
      fullPath: '/connected/bot'
      preLoaderRoute: typeof AppConnectedBotRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/business-value/smart-manufacturing': {
      id: '/_app/business-value/smart-manufacturing'
      path: '/business-value/smart-manufacturing'
      fullPath: '/business-value/smart-manufacturing'
      preLoaderRoute: typeof AppBusinessValueSmartManufacturingRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/business-value/logistics': {
      id: '/_app/business-value/logistics'
      path: '/business-value/logistics'
      fullPath: '/business-value/logistics'
      preLoaderRoute: typeof AppBusinessValueLogisticsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/business-value/energy': {
      id: '/_app/business-value/energy'
      path: '/business-value/energy'
      fullPath: '/business-value/energy'
      preLoaderRoute: typeof AppBusinessValueEnergyRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/business-value/data-centers': {
      id: '/_app/business-value/data-centers'
      path: '/business-value/data-centers'
      fullPath: '/business-value/data-centers'
      preLoaderRoute: typeof AppBusinessValueDataCentersRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/automotive/knowledge-graph': {
      id: '/_app/automotive/knowledge-graph'
      path: '/automotive/knowledge-graph'
      fullPath: '/automotive/knowledge-graph'
      preLoaderRoute: typeof AppAutomotiveKnowledgeGraphRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/automotive/flow': {
      id: '/_app/automotive/flow'
      path: '/automotive/flow'
      fullPath: '/automotive/flow'
      preLoaderRoute: typeof AppAutomotiveFlowRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/automotive/explorer': {
      id: '/_app/automotive/explorer'
      path: '/automotive/explorer'
      fullPath: '/automotive/explorer'
      preLoaderRoute: typeof AppAutomotiveExplorerRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/automotive/bot': {
      id: '/_app/automotive/bot'
      path: '/automotive/bot'
      fullPath: '/automotive/bot'
      preLoaderRoute: typeof AppAutomotiveBotRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/admin/users': {
      id: '/_app/admin/users'
      path: '/users'
      fullPath: '/admin/users'
      preLoaderRoute: typeof AppAdminUsersRouteImport
      parentRoute: typeof AppAdminRoute
    }
    '/_app/admin/settings': {
      id: '/_app/admin/settings'
      path: '/settings'
      fullPath: '/admin/settings'
      preLoaderRoute: typeof AppAdminSettingsRouteImport
      parentRoute: typeof AppAdminRoute
    }
    '/_app/admin/playground-nodes': {
      id: '/_app/admin/playground-nodes'
      path: '/playground-nodes'
      fullPath: '/admin/playground-nodes'
      preLoaderRoute: typeof AppAdminPlaygroundNodesRouteImport
      parentRoute: typeof AppAdminRoute
    }
    '/_app/admin/k8s': {
      id: '/_app/admin/k8s'
      path: '/k8s'
      fullPath: '/admin/k8s'
      preLoaderRoute: typeof AppAdminK8sRouteImport
      parentRoute: typeof AppAdminRoute
    }
    '/_app/admin/flow-templates': {
      id: '/_app/admin/flow-templates'
      path: '/flow-templates'
      fullPath: '/admin/flow-templates'
      preLoaderRoute: typeof AppAdminFlowTemplatesRouteImport
      parentRoute: typeof AppAdminRoute
    }
    '/_app/admin/customers': {
      id: '/_app/admin/customers'
      path: '/customers'
      fullPath: '/admin/customers'
      preLoaderRoute: typeof AppAdminCustomersRouteImport
      parentRoute: typeof AppAdminRoute
    }
    '/_app/admin/audit': {
      id: '/_app/admin/audit'
      path: '/audit'
      fullPath: '/admin/audit'
      preLoaderRoute: typeof AppAdminAuditRouteImport
      parentRoute: typeof AppAdminRoute
    }
    '/_app/admin/activity-users': {
      id: '/_app/admin/activity-users'
      path: '/activity-users'
      fullPath: '/admin/activity-users'
      preLoaderRoute: typeof AppAdminActivityUsersRouteImport
      parentRoute: typeof AppAdminRoute
    }
    '/_app/admin/activity-pages': {
      id: '/_app/admin/activity-pages'
      path: '/activity-pages'
      fullPath: '/admin/activity-pages'
      preLoaderRoute: typeof AppAdminActivityPagesRouteImport
      parentRoute: typeof AppAdminRoute
    }
    '/_app/admin/activity-external-links': {
      id: '/_app/admin/activity-external-links'
      path: '/activity-external-links'
      fullPath: '/admin/activity-external-links'
      preLoaderRoute: typeof AppAdminActivityExternalLinksRouteImport
      parentRoute: typeof AppAdminRoute
    }
    '/_app/admin/activity': {
      id: '/_app/admin/activity'
      path: '/activity'
      fullPath: '/admin/activity'
      preLoaderRoute: typeof AppAdminActivityRouteImport
      parentRoute: typeof AppAdminRoute
    }
  }
}

interface AppAdminRouteChildren {
  AppAdminActivityRoute: typeof AppAdminActivityRoute
  AppAdminActivityExternalLinksRoute: typeof AppAdminActivityExternalLinksRoute
  AppAdminActivityPagesRoute: typeof AppAdminActivityPagesRoute
  AppAdminActivityUsersRoute: typeof AppAdminActivityUsersRoute
  AppAdminAuditRoute: typeof AppAdminAuditRoute
  AppAdminCustomersRoute: typeof AppAdminCustomersRoute
  AppAdminFlowTemplatesRoute: typeof AppAdminFlowTemplatesRoute
  AppAdminK8sRoute: typeof AppAdminK8sRoute
  AppAdminPlaygroundNodesRoute: typeof AppAdminPlaygroundNodesRoute
  AppAdminSettingsRoute: typeof AppAdminSettingsRoute
  AppAdminUsersRoute: typeof AppAdminUsersRoute
}

const AppAdminRouteChildren: AppAdminRouteChildren = {
  AppAdminActivityRoute: AppAdminActivityRoute,
  AppAdminActivityExternalLinksRoute: AppAdminActivityExternalLinksRoute,
  AppAdminActivityPagesRoute: AppAdminActivityPagesRoute,
  AppAdminActivityUsersRoute: AppAdminActivityUsersRoute,
  AppAdminAuditRoute: AppAdminAuditRoute,
  AppAdminCustomersRoute: AppAdminCustomersRoute,
  AppAdminFlowTemplatesRoute: AppAdminFlowTemplatesRoute,
  AppAdminK8sRoute: AppAdminK8sRoute,
  AppAdminPlaygroundNodesRoute: AppAdminPlaygroundNodesRoute,
  AppAdminSettingsRoute: AppAdminSettingsRoute,
  AppAdminUsersRoute: AppAdminUsersRoute,
}

const AppAdminRouteWithChildren = AppAdminRoute._addFileChildren(
  AppAdminRouteChildren,
)

interface AppRouteChildren {
  AppAdminRoute: typeof AppAdminRouteWithChildren
  AppDatahubRoute: typeof AppDatahubRoute
  AppDemoinfoRoute: typeof AppDemoinfoRoute
  AppDhanonymizeflowRoute: typeof AppDhanonymizeflowRoute
  AppDhftocflowRoute: typeof AppDhftocflowRoute
  AppDhgeolocationflowRoute: typeof AppDhgeolocationflowRoute
  AppDhsparkplugfanoutflowRoute: typeof AppDhsparkplugfanoutflowRoute
  AppHivemqagenticRoute: typeof AppHivemqagenticRoute
  AppHivemqedgeRoute: typeof AppHivemqedgeRoute
  AppHivemqintroRoute: typeof AppHivemqintroRoute
  AppHivemqpilarsRoute: typeof AppHivemqpilarsRoute
  AppHivemqvisionRoute: typeof AppHivemqvisionRoute
  AppMqttClientRoute: typeof AppMqttClientRoute
  AppPlaygroundRoute: typeof AppPlaygroundRoute
  AppPulseRoute: typeof AppPulseRoute
  AppValuespaceRoute: typeof AppValuespaceRoute
  AppIndexRoute: typeof AppIndexRoute
  AppAutomotiveBotRoute: typeof AppAutomotiveBotRoute
  AppAutomotiveExplorerRoute: typeof AppAutomotiveExplorerRoute
  AppAutomotiveFlowRoute: typeof AppAutomotiveFlowRoute
  AppAutomotiveKnowledgeGraphRoute: typeof AppAutomotiveKnowledgeGraphRoute
  AppBusinessValueDataCentersRoute: typeof AppBusinessValueDataCentersRoute
  AppBusinessValueEnergyRoute: typeof AppBusinessValueEnergyRoute
  AppBusinessValueLogisticsRoute: typeof AppBusinessValueLogisticsRoute
  AppBusinessValueSmartManufacturingRoute: typeof AppBusinessValueSmartManufacturingRoute
  AppConnectedBotRoute: typeof AppConnectedBotRoute
  AppConnectedExplorerRoute: typeof AppConnectedExplorerRoute
  AppConnectedFlowRoute: typeof AppConnectedFlowRoute
  AppConnectedKnowledgeGraphRoute: typeof AppConnectedKnowledgeGraphRoute
  AppConnectedTracingRoute: typeof AppConnectedTracingRoute
  AppCustomersSlugRoute: typeof AppCustomersSlugRoute
  AppDatacenterBotRoute: typeof AppDatacenterBotRoute
  AppDatacenterExplorerRoute: typeof AppDatacenterExplorerRoute
  AppDatacenterFlowRoute: typeof AppDatacenterFlowRoute
  AppDatacenterKnowledgeGraphRoute: typeof AppDatacenterKnowledgeGraphRoute
  AppDatacenterMultisiteflowRoute: typeof AppDatacenterMultisiteflowRoute
  AppEducationHivemqClusterRoute: typeof AppEducationHivemqClusterRoute
  AppEducationMqttRoute: typeof AppEducationMqttRoute
  AppEducationSparkplugRoute: typeof AppEducationSparkplugRoute
  AppEducationTlsMtlsRoute: typeof AppEducationTlsMtlsRoute
  AppEducationUnsRoute: typeof AppEducationUnsRoute
  AppEnergyBotRoute: typeof AppEnergyBotRoute
  AppEnergyExplorerRoute: typeof AppEnergyExplorerRoute
  AppEnergyFlowRoute: typeof AppEnergyFlowRoute
  AppEnergyKnowledgeGraphRoute: typeof AppEnergyKnowledgeGraphRoute
  AppFactoryAdvancedflowRoute: typeof AppFactoryAdvancedflowRoute
  AppFactoryBotRoute: typeof AppFactoryBotRoute
  AppFactoryExplorerRoute: typeof AppFactoryExplorerRoute
  AppFactoryFlowRoute: typeof AppFactoryFlowRoute
  AppFactoryKnowledgeGraphRoute: typeof AppFactoryKnowledgeGraphRoute
  AppFactoryLineRoute: typeof AppFactoryLineRoute
  AppFactoryMultisiteflowRoute: typeof AppFactoryMultisiteflowRoute
  AppLogisticsBotRoute: typeof AppLogisticsBotRoute
  AppLogisticsExplorerRoute: typeof AppLogisticsExplorerRoute
  AppLogisticsFlowRoute: typeof AppLogisticsFlowRoute
  AppLogisticsKnowledgeGraphRoute: typeof AppLogisticsKnowledgeGraphRoute
  AppOilandgasBotRoute: typeof AppOilandgasBotRoute
  AppOilandgasExplorerRoute: typeof AppOilandgasExplorerRoute
  AppOilandgasFlowRoute: typeof AppOilandgasFlowRoute
  AppOilandgasKnowledgeGraphRoute: typeof AppOilandgasKnowledgeGraphRoute
  AppPharmaBotRoute: typeof AppPharmaBotRoute
  AppPharmaExplorerRoute: typeof AppPharmaExplorerRoute
  AppPharmaFlowRoute: typeof AppPharmaFlowRoute
  AppPharmaKnowledgeGraphRoute: typeof AppPharmaKnowledgeGraphRoute
  AppAutomotiveIndexRoute: typeof AppAutomotiveIndexRoute
  AppBusinessValueIndexRoute: typeof AppBusinessValueIndexRoute
  AppConnectedIndexRoute: typeof AppConnectedIndexRoute
  AppDatacenterIndexRoute: typeof AppDatacenterIndexRoute
  AppEducationIndexRoute: typeof AppEducationIndexRoute
  AppEnergyIndexRoute: typeof AppEnergyIndexRoute
  AppFactoryIndexRoute: typeof AppFactoryIndexRoute
  AppLogisticsIndexRoute: typeof AppLogisticsIndexRoute
  AppOilandgasIndexRoute: typeof AppOilandgasIndexRoute
  AppPharmaIndexRoute: typeof AppPharmaIndexRoute
}

const AppRouteChildren: AppRouteChildren = {
  AppAdminRoute: AppAdminRouteWithChildren,
  AppDatahubRoute: AppDatahubRoute,
  AppDemoinfoRoute: AppDemoinfoRoute,
  AppDhanonymizeflowRoute: AppDhanonymizeflowRoute,
  AppDhftocflowRoute: AppDhftocflowRoute,
  AppDhgeolocationflowRoute: AppDhgeolocationflowRoute,
  AppDhsparkplugfanoutflowRoute: AppDhsparkplugfanoutflowRoute,
  AppHivemqagenticRoute: AppHivemqagenticRoute,
  AppHivemqedgeRoute: AppHivemqedgeRoute,
  AppHivemqintroRoute: AppHivemqintroRoute,
  AppHivemqpilarsRoute: AppHivemqpilarsRoute,
  AppHivemqvisionRoute: AppHivemqvisionRoute,
  AppMqttClientRoute: AppMqttClientRoute,
  AppPlaygroundRoute: AppPlaygroundRoute,
  AppPulseRoute: AppPulseRoute,
  AppValuespaceRoute: AppValuespaceRoute,
  AppIndexRoute: AppIndexRoute,
  AppAutomotiveBotRoute: AppAutomotiveBotRoute,
  AppAutomotiveExplorerRoute: AppAutomotiveExplorerRoute,
  AppAutomotiveFlowRoute: AppAutomotiveFlowRoute,
  AppAutomotiveKnowledgeGraphRoute: AppAutomotiveKnowledgeGraphRoute,
  AppBusinessValueDataCentersRoute: AppBusinessValueDataCentersRoute,
  AppBusinessValueEnergyRoute: AppBusinessValueEnergyRoute,
  AppBusinessValueLogisticsRoute: AppBusinessValueLogisticsRoute,
  AppBusinessValueSmartManufacturingRoute:
    AppBusinessValueSmartManufacturingRoute,
  AppConnectedBotRoute: AppConnectedBotRoute,
  AppConnectedExplorerRoute: AppConnectedExplorerRoute,
  AppConnectedFlowRoute: AppConnectedFlowRoute,
  AppConnectedKnowledgeGraphRoute: AppConnectedKnowledgeGraphRoute,
  AppConnectedTracingRoute: AppConnectedTracingRoute,
  AppCustomersSlugRoute: AppCustomersSlugRoute,
  AppDatacenterBotRoute: AppDatacenterBotRoute,
  AppDatacenterExplorerRoute: AppDatacenterExplorerRoute,
  AppDatacenterFlowRoute: AppDatacenterFlowRoute,
  AppDatacenterKnowledgeGraphRoute: AppDatacenterKnowledgeGraphRoute,
  AppDatacenterMultisiteflowRoute: AppDatacenterMultisiteflowRoute,
  AppEducationHivemqClusterRoute: AppEducationHivemqClusterRoute,
  AppEducationMqttRoute: AppEducationMqttRoute,
  AppEducationSparkplugRoute: AppEducationSparkplugRoute,
  AppEducationTlsMtlsRoute: AppEducationTlsMtlsRoute,
  AppEducationUnsRoute: AppEducationUnsRoute,
  AppEnergyBotRoute: AppEnergyBotRoute,
  AppEnergyExplorerRoute: AppEnergyExplorerRoute,
  AppEnergyFlowRoute: AppEnergyFlowRoute,
  AppEnergyKnowledgeGraphRoute: AppEnergyKnowledgeGraphRoute,
  AppFactoryAdvancedflowRoute: AppFactoryAdvancedflowRoute,
  AppFactoryBotRoute: AppFactoryBotRoute,
  AppFactoryExplorerRoute: AppFactoryExplorerRoute,
  AppFactoryFlowRoute: AppFactoryFlowRoute,
  AppFactoryKnowledgeGraphRoute: AppFactoryKnowledgeGraphRoute,
  AppFactoryLineRoute: AppFactoryLineRoute,
  AppFactoryMultisiteflowRoute: AppFactoryMultisiteflowRoute,
  AppLogisticsBotRoute: AppLogisticsBotRoute,
  AppLogisticsExplorerRoute: AppLogisticsExplorerRoute,
  AppLogisticsFlowRoute: AppLogisticsFlowRoute,
  AppLogisticsKnowledgeGraphRoute: AppLogisticsKnowledgeGraphRoute,
  AppOilandgasBotRoute: AppOilandgasBotRoute,
  AppOilandgasExplorerRoute: AppOilandgasExplorerRoute,
  AppOilandgasFlowRoute: AppOilandgasFlowRoute,
  AppOilandgasKnowledgeGraphRoute: AppOilandgasKnowledgeGraphRoute,
  AppPharmaBotRoute: AppPharmaBotRoute,
  AppPharmaExplorerRoute: AppPharmaExplorerRoute,
  AppPharmaFlowRoute: AppPharmaFlowRoute,
  AppPharmaKnowledgeGraphRoute: AppPharmaKnowledgeGraphRoute,
  AppAutomotiveIndexRoute: AppAutomotiveIndexRoute,
  AppBusinessValueIndexRoute: AppBusinessValueIndexRoute,
  AppConnectedIndexRoute: AppConnectedIndexRoute,
  AppDatacenterIndexRoute: AppDatacenterIndexRoute,
  AppEducationIndexRoute: AppEducationIndexRoute,
  AppEnergyIndexRoute: AppEnergyIndexRoute,
  AppFactoryIndexRoute: AppFactoryIndexRoute,
  AppLogisticsIndexRoute: AppLogisticsIndexRoute,
  AppOilandgasIndexRoute: AppOilandgasIndexRoute,
  AppPharmaIndexRoute: AppPharmaIndexRoute,
}

const AppRouteWithChildren = AppRoute._addFileChildren(AppRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  AppRoute: AppRouteWithChildren,
  ApplicationflowRoute: ApplicationflowRoute,
  ApplicationintroRoute: ApplicationintroRoute,
  ApplicationunsRoute: ApplicationunsRoute,
  CarRoute: CarRoute,
  ConfigurationRoute: ConfigurationRoute,
  DhhomeRoute: DhhomeRoute,
  HivemqdatahubRoute: HivemqdatahubRoute,
  HomeRoute: HomeRoute,
  IntroslidesRoute: IntroslidesRoute,
  LicensingslidesRoute: LicensingslidesRoute,
  LoginRoute: LoginRoute,
  ShowconfigurationRoute: ShowconfigurationRoute,
  ShowinfosRoute: ShowinfosRoute,
  LoginCallbackRoute: LoginCallbackRoute,
  SShortCodeRoute: SShortCodeRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
